<template>
  <!-- <img alt="Vue logo" src="./assets/logo.gif"> -->
  <!-- <img alt="Vue logo" src="./assets/Infinity@1x-1.0s-200px-200px.gif"> -->
   <!-- <img src="https://www.dropbox.com/scl/fi/xo6tdh6txuz6836dlibl9/33663.jpg?rlkey=8jn7aoezsqbwj1vtkjmhbi5tg&e=2&raw=1" alt=""> -->
  <!-- <HelloWorld msg="Top page"/> -->
  <main>
    <RouterView />
  </main>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import { useCookies } from "vue3-cookies";
 const { cookies } = useCookies();
export default {
  name: 'App',
  components: {
    // HelloWorld
  },
  data() {
    return {
      apiURL: ''
    }
  },
  methods: {
    checkAlive () {
      let url = process.env.VUE_APP_API_BASE_URL+"/keepAlive"
      this.axios.get(url).then((response) => { 
        console.log(response.data)
      })
    },
    getUserPreferences (user) {
      let url = process.env.VUE_APP_API_BASE_URL+"/getUserPreferences"
      this.axios.post(url, {
        user          
      }).then((response) => { 
        console.log(response.data)
      })
    }
  },
  mounted() {
    console.log(process.env, 'envionment vars')
    // this.apiURL = process.env.NODE_ENV == 'development' ? 'http://localhost:3000' : `/api/`
    // to use other service's ip address
    // in Kubernetes process.env.AUTH_SERVICE_SERVICE_HOST
    // or if use docker compopse ...use <SERVICE_NAME> 
    this.checkAlive()

    let identity = cookies.get("tkcID"), tkcToken = cookies.get("tkcTok");
    console.log('cookie', identity, tkcToken)
    
     if(process.env.NODE_ENV == 'development') {
        identity = {
          email: "rogert@turtleking.com",
            id: 10,
            name: "Roger",
            type: "admin",
            vendor_id: ""
        } 
        tkcToken = 'testToken'
      }
      




    
    if(identity == null || tkcToken == null) {
      console.log('redirect')
      window.location.href = "https://vendor.turtleking.com/logout";
      return false;
    } else {
      console.log('authenticated from vendor site. continuing on')
    }
  }
}
</script>

<style lang="scss">
  html{
    background-color:#ebebeb;
  }
  #app {
    // font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;

    font: 14px / 20px 'Montserrat', Arial, Helvetica, sans-serif;
    h3{
      font-family: 'Montserrat', Arial, Helvetica, sans-serif;
      font-weight: bold;
    }
    // margin-top: 60px;
    // input[type=password] {
    //       border: 2px solid #b3b3b3;
    // outline: 0;
    // margin: 2px;
    // }
  }
</style>
